import { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import axios from "axios";

import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import { Toast } from 'primereact/toast';
import LoadingOverlay from '../components/LoadingOverlay';

const UnidadFuncional = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ Estado â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormData = {
        unidadFuncionalId: 0,
        unidadFuncional: "",
        direccion: "",
        bloque: "",
        unidadComplementariaCochera: "",
        partidaArba: "",
        departamento: "",
        ph: "",
        planoUnidadFuncional: "",
        piso: "",
        puerta: "",
        lote: "",
        manzana: "",
        unidadFuncionalM2: "",
        codigoUF: "",
        idTipoUnidadFuncional: null,
        activo: true,
    };

    const [formData, setFormData] = useState(initialFormData);
    const [visible, setVisible] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [personasCombo, setPersonasCombo] = useState([]);
    const [tiposRelacion, setTiposRelacion] = useState([]);
    const [tiposUnidadFuncional, setTiposUnidadFuncional] = useState([]);
    const [guardandoUF, setGuardandoUF] = useState(false);

    // ─── Personas asignadas a la UF (Propietario / Inquilino, etc.) ───────────────
    const [historialPersonas, setHistorialPersonas] = useState([]);
    const [loadingHistorial, setLoadingHistorial] = useState(false);
    const [personaNueva, setPersonaNueva] = useState(null);
    const [tipoRelacionNueva, setTipoRelacionNueva] = useState(null);
    const [fechaDesdeNueva, setFechaDesdeNueva] = useState(new Date());
    const [fechaHastaNueva, setFechaHastaNueva] = useState(null);
    const [agregandoPersona, setAgregandoPersona] = useState(false);

    const tipoRelacionLabel = (tipoRelacionId) =>
        tiposRelacion.find((tr) => tr.tipoRelacionId === tipoRelacionId)?.descripcion || '—';

    const handleChange = (campo, valor) => {
        setFormData((prev) => ({ ...prev, [campo]: valor }));
    };

    // â”€â”€â”€ Submit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleSubmit = async (e) => {
        e.preventDefault();

        // La columna en la base es numérica -- si se escribe una letra ahí (ej. "1A"),
        // SQL Server rechaza el guardado con un error críptico de conversión. Se valida
        // acá antes de mandarlo, con un mensaje que explica dónde va la letra/detalle.
        if (formData.unidadFuncional === '' || formData.unidadFuncional == null) {
            toast.current.show({ severity: 'warn', summary: 'Falta un dato', detail: `Ingresá el número de ${t.unidadFuncional}`, life: 3500 });
            return;
        }
        if (!/^\d+$/.test(String(formData.unidadFuncional))) {
            toast.current.show({
                severity: 'warn',
                summary: `${t.UnidadFuncional} inválida`,
                detail: `El número de ${t.unidadFuncional} solo puede tener dígitos. Si necesitás agregar una letra o un detalle, usá los campos Piso, Puerta, Bloque, Manzana o Lote.`,
                life: 6000,
            });
            return;
        }

        setGuardandoUF(true);
        const payload = {
            ...formData,
            unidadFuncional: String(formData.unidadFuncional),
            barrioId: barrio.id,
            administracionId,
        };
        try {
            const { data } = await axios.post(`${HOST_API}api/unidadesFuncionales/saveUnidadFuncional`, payload);
            const unidadFuncionalId = data?.unidadFuncionalId || formData.unidadFuncionalId;

            // No cerramos el modal: si es alta, esto habilita la sección de
            // Personas (que necesita el id ya generado) sin perder el formulario.
            setFormData((prev) => ({ ...prev, unidadFuncionalId }));
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: `${t.UnidadFuncional} guardada correctamente`, life: 2500 });
            fetchUnidades();
            fetchHistorial(unidadFuncionalId);
        } catch (err) {
            console.error(err);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: err?.response?.data?.errorDisplay || 'No se pudo guardar la unidad funcional',
                life: 4000,
            });
        } finally {
            setGuardandoUF(false);
        }
    };

    // ─── Personas: alta individual + historial activo ─────────────────────────────

    const fetchHistorial = useCallback(async (unidadFuncionalId) => {
        if (!unidadFuncionalId) { setHistorialPersonas([]); return; }
        setLoadingHistorial(true);
        try {
            const { data } = await axios.get(`${HOST_API}api/unidadFuncionalPersona/GetHistorialUF?unidadFuncionalId=${unidadFuncionalId}`);
            setHistorialPersonas((data ?? []).filter((p) => !p.fechaHasta));
        } catch {
            setHistorialPersonas([]);
        } finally {
            setLoadingHistorial(false);
        }
    }, [HOST_API]);

    const agregarPersona = async () => {
        if (!personaNueva) { toast.current.show({ severity: 'warn', summary: 'Requerido', detail: 'Seleccioná una persona', life: 3000 }); return; }
        if (!tipoRelacionNueva) { toast.current.show({ severity: 'warn', summary: 'Requerido', detail: 'Seleccioná el tipo de relación', life: 3000 }); return; }
        if (!fechaDesdeNueva) { toast.current.show({ severity: 'warn', summary: 'Requerido', detail: 'Ingresá la fecha desde', life: 3000 }); return; }
        if (fechaHastaNueva && fechaHastaNueva < fechaDesdeNueva) { toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'La fecha hasta no puede ser anterior a la fecha desde', life: 3000 }); return; }
        setAgregandoPersona(true);
        try {
            await axios.post(`${HOST_API}api/unidadFuncionalPersona/AgregarPersona`, {
                unidadFuncionalId: formData.unidadFuncionalId,
                personaId: personaNueva,
                tipoRelacionId: tipoRelacionNueva,
                administracionId,
                fechaDesde: fechaDesdeNueva,
                fechaHasta: fechaHastaNueva,
            });
            setPersonaNueva(null);
            setTipoRelacionNueva(null);
            setFechaDesdeNueva(new Date());
            setFechaHastaNueva(null);
            fetchHistorial(formData.unidadFuncionalId);
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.errorDisplay || 'No se pudo agregar la persona', life: 4000 });
        } finally {
            setAgregandoPersona(false);
        }
    };

    const finalizarPersona = (row) => {
        confirmDialog({
            message: `¿Quitar a ${row.nombreCompleto} (${tipoRelacionLabel(row.tipoRelacionId)}) de esta ${t.unidadFuncional}?`,
            header: 'Confirmar',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Quitar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.put(`${HOST_API}api/unidadFuncionalPersona/FinalizarRelacionUF`, null, {
                        params: { unidadFuncionalPersonaId: row.unidadFuncionalPorPersonaId, administracionId },
                    });
                    fetchHistorial(formData.unidadFuncionalId);
                } catch {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo quitar la persona', life: 3000 });
                }
            },
        });
    };

    // â”€â”€â”€ Fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const fetchUnidades = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(
                `${HOST_API}api/unidadesFuncionales/getUnidadesFuncionales?unidadFuncionalId=0&administracionId=${administracionId}&barrioId=${barrio.id}`
            );
            console.log(response.data);
            setUnidades(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener unidades funcionales");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [barrio?.id, administracionId]);

    useEffect(() => {
        fetchUnidades();
    }, [fetchUnidades]);

    useEffect(() => {
        if (!barrio?.id) return;
        axios.get(`${HOST_API}api/personas/GetPersonasCombo?administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(({ data }) => setPersonasCombo(data))
            .catch(() => {});
    }, [barrio?.id, HOST_API, administracionId]);

    useEffect(() => {
        axios.get(`${HOST_API}api/tiporelacionpersona/GetTipoRelacionPersonas`)
            .then(({ data }) => setTiposRelacion(data ?? []))
            .catch(() => {});
    }, [HOST_API]);

    useEffect(() => {
        axios.get(`${HOST_API}api/tipoUnidadFuncional/GetTipoUnidadFuncional`)
            .then(({ data }) => setTiposUnidadFuncional(data ?? []))
            .catch(() => {});
    }, [HOST_API]);

    const unidadesFlat = useMemo(() => unidades?.map(flattenRow) ?? [], [unidades]);

    const columns = useMemo(() => {
        if (!unidadesFlat?.length) return [];
        const firstRow = unidadesFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && key !== 'administracionId' && key !== 'barrioId' && key !== 'fechaAlta' && key !== 'activo' && key !== 'nombreCompleto' && key !== 'personaId' && key !== 'asamblea' && key !== 'idTipoUnidadFuncional')
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: field === 'unidadFuncional' ? t.UnidadFuncional : camelToHeader(field),
            }));
    }, [unidades, t.UnidadFuncional]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = async (row) => {
        setFormData({ ...initialFormData, ...row });
        setPersonaNueva(null);
        setTipoRelacionNueva(null);
        setFechaDesdeNueva(new Date());
        setFechaHastaNueva(null);
        setVisible(true);
        fetchHistorial(row.unidadFuncionalId);
    };

    const handleDelete = (id) => {
        confirmDialog({
            message: `¿Estás seguro de eliminar este/a ${t.unidadFuncional}?`,
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/unidadesFuncionales/deleteUnidadFuncional/${id}`);
                    fetchUnidades();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>{t.UnidadFuncional}</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <LoadingOverlay visible={loadingBackdrop} />

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label={`Nuevo/a ${t.unidadFuncional}`}
                    icon="pi pi-plus"
                    onClick={() => {
                        setFormData(initialFormData);
                        setHistorialPersonas([]);
                        setPersonaNueva(null);
                        setTipoRelacionNueva(null);
                        setFechaDesdeNueva(new Date());
                        setFechaHastaNueva(null);
                        setVisible(true);
                    }}
                />
            </div>

            <Dialog
                header={t.UnidadFuncional}
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisible(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-4">
                                <label>{t.UnidadFuncional} (número)</label>
                                <InputNumber
                                    value={formData.unidadFuncional === '' ? null : Number(formData.unidadFuncional)}
                                    onValueChange={(e) => handleChange("unidadFuncional", e.value ?? "")}
                                    useGrouping={false}
                                    min={0}
                                    className="p-inputtext-sm w-full"
                                    placeholder="Ej: 12"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Código UF</label>
                                <InputText
                                    type="text"
                                    value={formData.codigoUF || ""}
                                    onChange={(e) => handleChange("codigoUF", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Tipo</label>
                                <Dropdown
                                    value={formData.idTipoUnidadFuncional ?? null}
                                    options={tiposUnidadFuncional}
                                    optionLabel="descripcion"
                                    optionValue="idTipoUnidadFuncional"
                                    onChange={(e) => handleChange("idTipoUnidadFuncional", e.value ?? null)}
                                    placeholder="Seleccionar tipo"
                                    showClear
                                    filter
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Dirección</label>
                                <InputText
                                    type="text"
                                    value={formData.direccion || ""}
                                    onChange={(e) => handleChange("direccion", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Bloque</label>
                                <InputText
                                    type="text"
                                    value={formData.bloque || ""}
                                    onChange={(e) => handleChange("bloque", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Piso</label>
                                <InputText
                                    type="text"
                                    value={formData.piso || ""}
                                    onChange={(e) => handleChange("piso", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Puerta</label>
                                <InputText
                                    type="text"
                                    value={formData.puerta || ""}
                                    onChange={(e) => handleChange("puerta", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Departamento</label>
                                <InputText
                                    type="text"
                                    value={formData.departamento || ""}
                                    onChange={(e) => handleChange("departamento", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>PH</label>
                                <InputText
                                    type="text"
                                    value={formData.ph || ""}
                                    onChange={(e) => handleChange("ph", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Lote</label>
                                <InputText
                                    type="text"
                                    value={formData.lote || ""}
                                    onChange={(e) => handleChange("lote", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Manzana</label>
                                <InputText
                                    type="text"
                                    value={formData.manzana || ""}
                                    onChange={(e) => handleChange("manzana", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>M²</label>
                                <InputText
                                    type="text"
                                    value={formData.unidadFuncionalM2 || ""}
                                    onChange={(e) => handleChange("unidadFuncionalM2", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Cochera</label>
                                <InputText
                                    type="text"
                                    value={formData.unidadComplementariaCochera || ""}
                                    onChange={(e) => handleChange("unidadComplementariaCochera", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Partida ARBA</label>
                                <InputText
                                    type="text"
                                    value={formData.partidaArba || ""}
                                    onChange={(e) => handleChange("partidaArba", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Plano UF</label>
                                <InputText
                                    type="text"
                                    value={formData.planoUnidadFuncional || ""}
                                    onChange={(e) => handleChange("planoUnidadFuncional", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activo"
                                    checked={formData.activo}
                                    onChange={(e) => handleChange("activo", e.checked)}
                                />
                                <label htmlFor="activo">Activo</label>
                            </div>

                            <div className="col-12 mt-3">
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Personas</label>
                                {!formData.unidadFuncionalId ? (
                                    <p style={{ color: '#98a2b3', fontSize: '0.85rem', margin: 0 }}>
                                        Guardá la {t.unidadFuncional} para poder asignarle personas.
                                    </p>
                                ) : (
                                    <>
                                        <div className="flex gap-2 flex-wrap align-items-end mb-2">
                                            <div style={{ flex: '1 1 220px' }}>
                                                <Dropdown
                                                    value={personaNueva}
                                                    options={personasCombo}
                                                    optionLabel="nombreCompleto"
                                                    optionValue="personaId"
                                                    onChange={(e) => setPersonaNueva(e.value)}
                                                    placeholder="Seleccionar persona"
                                                    filter
                                                    className="p-inputtext-sm w-full"
                                                />
                                            </div>
                                            <div style={{ flex: '1 1 160px' }}>
                                                <Dropdown
                                                    value={tipoRelacionNueva}
                                                    options={tiposRelacion}
                                                    optionLabel="descripcion"
                                                    optionValue="tipoRelacionId"
                                                    onChange={(e) => setTipoRelacionNueva(e.value)}
                                                    placeholder="Tipo de relación"
                                                    className="p-inputtext-sm w-full"
                                                />
                                            </div>
                                            <div style={{ flex: '1 1 130px' }}>
                                                <Calendar
                                                    value={fechaDesdeNueva}
                                                    onChange={(e) => setFechaDesdeNueva(e.value)}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="Desde"
                                                    showIcon
                                                    className="p-inputtext-sm w-full"
                                                />
                                            </div>
                                            <div style={{ flex: '1 1 130px' }}>
                                                <Calendar
                                                    value={fechaHastaNueva}
                                                    onChange={(e) => setFechaHastaNueva(e.value)}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="Hasta (opcional)"
                                                    showIcon
                                                    showButtonBar
                                                    className="p-inputtext-sm w-full"
                                                />
                                            </div>
                                            <Button
                                                type="button"
                                                label="Agregar"
                                                icon="pi pi-plus"
                                                className="p-button-sm"
                                                onClick={agregarPersona}
                                                loading={agregandoPersona}
                                            />
                                        </div>

                                        {loadingHistorial ? (
                                            <p style={{ color: '#98a2b3', fontSize: '0.85rem', margin: 0 }}>Cargando...</p>
                                        ) : historialPersonas.length === 0 ? (
                                            <p style={{ color: '#98a2b3', fontSize: '0.85rem', margin: 0 }}>Todavía no hay personas asignadas.</p>
                                        ) : (
                                            <div className="flex flex-column gap-2">
                                                {historialPersonas.map((p) => (
                                                    <div key={p.unidadFuncionalPorPersonaId}
                                                        className="flex align-items-center justify-content-between"
                                                        style={{ border: '1px solid #e4e7ec', borderRadius: 8, padding: '0.5rem 0.75rem' }}>
                                                        <div className="flex flex-column gap-1">
                                                            <div className="flex align-items-center gap-2">
                                                                <span style={{ fontWeight: 600, fontSize: '0.88rem' }}>{p.nombreCompleto}</span>
                                                                <span style={{
                                                                    background: '#eff8ff', color: '#1570ef', border: '1px solid #b2ddff',
                                                                    fontWeight: 600, fontSize: '0.72rem', padding: '0.1rem 0.55rem', borderRadius: 99,
                                                                }}>
                                                                    {tipoRelacionLabel(p.tipoRelacionId)}
                                                                </span>
                                                            </div>
                                                            <span style={{ color: '#667085', fontSize: '0.76rem' }}>
                                                                {formatValue(p.fechaDesde, 'date')}
                                                                {' - '}
                                                                {p.fechaHasta ? formatValue(p.fechaHasta, 'date') : 'Actualidad'}
                                                            </span>
                                                        </div>
                                                        <Button icon="pi pi-times" rounded text severity="danger"
                                                            tooltip="Quitar" tooltipOptions={{ position: 'top' }}
                                                            onClick={() => finalizarPersona(p)} />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            <div className="col-12 mt-3 flex gap-2">
                                <Button label="Guardar" icon="pi pi-save" type="submit" loading={guardandoUF} />
                                <Button label="Cerrar" type="button" className="p-button-text" onClick={() => setVisible(false)} />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={unidadesFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay unidades funcionales cargadas"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columns.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Tipo"
                            body={(row) => tiposUnidadFuncional.find((tp) => tp.idTipoUnidadFuncional === row.idTipoUnidadFuncional)?.descripcion || ''}
                        />
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={(row) => {
                                const s = row.activo
                                    ? { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5', label: 'Activo' }
                                    : { bg: '#fef3f2', color: '#f04438', border: '#fecdca', label: 'No Activo' };
                                return (
                                    <span style={{
                                        background: s.bg, color: s.color, border: `1px solid ${s.border}`,
                                        fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
                                    }}>
                                        {s.label}
                                    </span>
                                );
                            }}
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.unidadFuncionalId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default UnidadFuncional;
